import { useSelector } from "react-redux";
import useClientContext from "../contexts/useClientContext";
import { impersonationSelector } from "../store/state/user/selectors";
import type { InvestorRelationPortalFeatures } from "../store/state/user/types";

export type PageStatus = "live" | "preview";

export const useImpersonationPageStatus = (
  requiredFeature: InvestorRelationPortalFeatures | undefined
): PageStatus | undefined => {
  const { isFeatureEnabledInLive, isFeatureEnabledInPreview, dashboardWidgets, portfolioWidget } = useClientContext();

  const isImpersonationMode = useSelector(impersonationSelector);

  const isPageContentLive = (feature: InvestorRelationPortalFeatures) => {
    switch (feature) {
      case "Dashboards":
        return dashboardWidgets.some((w) => w.status === "Live");
      case "PortfolioCompanies":
        return portfolioWidget?.status === "Live";
      default:
        return true;
    }
  };

  if (!requiredFeature || !isImpersonationMode) {
    return undefined;
  }
  if (isFeatureEnabledInLive(requiredFeature)) {
    return isPageContentLive(requiredFeature) ? "live" : "preview";
  }
  if (isFeatureEnabledInPreview(requiredFeature)) {
    return "preview";
  }
  return undefined;
};
